import { OrgSettings } from 'src/components';

export const OrganizationSettings = () => {
  return <OrgSettings />;
};
